const routes = [
    {
        path: '/',
        // name: 'Index',
        component: () => import('@/views/vipCourse/index')
    },
    {
        path: '/paySuccess',
        component: () => import('@/views/vipCourse/paySuccess')
    }
];

export default routes;
